






































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import ApdSurveilansService from "@/services/ApdSurveilansService";
import ApdSurveilansObservasiLogger from "./ApdSurveilansObservasiLogger.vue";
import ApdSurveilansDetail from "./ApdSurveilansDetail.vue";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";
import { userModule } from "@/store/modules/user";

@Component({
  components: { ApdSurveilansObservasiLogger, ApdSurveilansDetail, UnitRuangPicker }
})
export default class ApdSurveilansList extends Vue {
  mode: "list" | "create" | "logger" | "detail" = "list";
  currentSessionId = 0;

  sessions: any[] = [];
  loading = false;
  creating = false;

  filterUnit: string | null = null;
  filterTglDari = "";
  filterTglSampai = "";
  filterStatus: string | null = null;
  filterKategori: string | null = null;

  form: any = {
    unit_id: "",
    unit_nama: "",
    periode_mulai: "",
    periode_akhir: "",
    shift: "pagi",
    auditor_nip: "",
    auditor_jabatan: "",
    auditor_komite_ppi: ""
  };

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "Submitted Auditor", value: "submitted" },
    { text: "Verified Ka. Unit", value: "verified_kaunit" },
    { text: "Approved Komite PPI", value: "approved_komite_ppi" },
    { text: "Approved Pimpinan", value: "approved_pimpinan" },
    { text: "Closed", value: "closed" }
  ];

  kategoriOptions = [
    { text: "Baik (≥95%)", value: "baik" },
    { text: "Cukup (76–94%)", value: "cukup" },
    { text: "Kurang (<76%)", value: "kurang" }
  ];

  shiftOptions = [
    { text: "Pagi", value: "pagi" },
    { text: "Sore", value: "sore" },
    { text: "Malam", value: "malam" }
  ];

  headers = [
    { text: "Nomor", value: "nomor_formulir" },
    { text: "Periode", value: "periode" },
    { text: "Unit", value: "unit_nama" },
    { text: "Shift", value: "shift" },
    { text: "Obs. Petugas", value: "total_observasi_petugas", width: 80 },
    { text: "Compliance", value: "compliance_rate_total" },
    { text: "Kategori", value: "kategori_kepatuhan" },
    { text: "Status", value: "status" },
    { text: "", value: "actions", sortable: false, width: 120 }
  ];

  get namaAuditor(): string {
    return userModule.user?.nama || "-";
  }

  get bolehLintasUnit(): boolean {
    return (
      userModule.isSuperAdmin ||
      userModule.hasAssignedPrivilege("surveilans_apd", "view")
    );
  }

  get unitTerkunci(): boolean {
    if (!userModule.scopedUnitId) return false;
    return userModule.isUnitScopeLocked || !this.bolehLintasUnit;
  }

  async mounted() {
    this.filterUnit = userModule.scopedUnitId;
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: any = {};
      if (this.filterUnit) params.unit_id = this.filterUnit;
      if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
      if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
      if (this.filterStatus) params.status = this.filterStatus;
      if (this.filterKategori) params.kategori_kepatuhan = this.filterKategori;
      const res = await ApdSurveilansService.getList({ params });
      this.sessions = res.data.data.data || res.data.data;
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.mode = "create";
    this.form.periode_akhir = localISODate();
    this.form.periode_mulai = localISODate();
    this.form.unit_id = userModule.scopedUnitId || "";
    this.form.unit_nama = "";
  }

  onUnitChange(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  async createSession() {
    this.creating = true;
    try {
      const res = await ApdSurveilansService.create(this.form);
      const sess = res.data.data;
      this.currentSessionId = sess.id;
      this.mode = "logger";
    } finally {
      this.creating = false;
    }
  }

  openLogger(item: any) {
    this.currentSessionId = item.id;
    this.mode = "logger";
  }

  openDetail(item: any) {
    this.currentSessionId = item.id;
    this.mode = "detail";
  }

  async returnToList() {
    this.mode = "list";
    await this.loadData();
  }

  printPdf(id: number) {
    ApdSurveilansService.printPdf(id);
  }

  formatDate(s: string) {
    if (!s) return "-";
    const d = new Date(s);
    return d.toLocaleDateString("id-ID");
  }

  getComplianceColor(rate: number) {
    if (!rate) return "grey";
    if (rate >= 95) return "success";
    if (rate >= 76) return "warning";
    return "error";
  }
}
